import { IDName, SoftDeletable } from '@damofire/data-commons';
import { OrganizationInfos } from '@damofire/data-stas';

export enum DocumentType {
  INSPECTION = 'inspection',
  ENGINEERING_REPORT = 'engineering_report',
  // QUOTE = 'quote',
  // REPAIR_CERTIFICATION = 'repair_certification',
}

export interface Document extends OrganizationInfos {
  filename?: string;
  path?: string;
  size?: number;
  type?: DocumentType;
  contentType?: string;
  inspection?: IDName & SoftDeletable;
  version?: string;
  description?: string;
  undisclosed?: boolean;
}

export interface DocumentMeta {
  description?: string;
  undisclosed?: string;
  /** Set to 'true' when PDFs have already been extracted client-side before upload. */
  extracted?: string;
}

export enum UploadStatus {
  HAS_FILE,
  DONE,
  UPLOADING,
}
